const messages = {
  'about.title': 'About the service - Varaamo',
  'app.about': 'About',
  'app.login': 'Log in',
  'app.logout': 'Log out',
  'app.my_reservations': 'My reservations',
  'app.search': 'Search',
  'home.title': 'Home - Varaamo',
  'home.what_purpose': 'What would you like to do?',
  'imagepanel.images': 'Images',
  'login.back': 'Back',
  'login.login': 'Log in',
  'login.login_and_save': 'Log in and save',
  'login.password': 'PIN',
  'login.modal_title': 'Log in',
  'login.username': 'Library card number',
  'multiday.begin': 'Begins',
  'multiday.cancel': 'Cancel',
  'multiday.end': 'Ends',
  'multiday.header': 'Make a reservation for multiple days',
  'myreservations.no_ordinary': 'No regular reservations to show.',
  'myreservations.no_preliminary': 'No preliminary reservations to show.',
  'myreservations.ordinary_reservations': 'Regular reservations',
  'myreservations.page_header': 'My Reservations',
  'myreservations.preliminary_reservations': 'Preliminary reservations',
  'myreservations.title': 'My Reservations - Varaamo',
  'notfound.title': '404 Page not Found - Varaamo',
  'ResourceAvailability.available': 'Available right now',
  'ResourceAvailability.availableAt': 'Available at {time}',
  'ResourceAvailability.closed': 'Closed',
  'ResourceAvailability.reserved': 'Reserved for the whole day',
  'reservation.accept': 'Accept',
  'reservation.all': 'All',
  'reservation.cancel': 'Cancel',
  'reservation.edit': 'Edit',
  'reservation.information': 'Information',
  'reservation.reject': 'Reject',
  'reservation.reservation_status': 'Reservation Status',
  'reservation_calendar.back': 'Back',
  'reservation_calendar.choose_time': 'Select the time you want to reserve.',
  'reservation_calendar.confirm_changes': 'Confirm changes',
  'reservation_calendar.go_to_selected': 'Go to selected',
  'reservation_calendar.reserve': 'Reserve',
  'reservation_calendar.reserving': 'Reserving...',
  'reservation_calendar.saving': 'Saving...',
  'reservation_calendar.today': 'Today',
  'reservation_cancel.are_you_sure': `Are you sure you want to cancel the following {num, plural,
      one {reservation}
      other {reservations}
      }:`,
  'reservation_cancel.back': 'Back',
  'reservation_cancel.by_contact': `This reservation must be canceled via the responsible
                                   official. If you want to cancel the reservation or
                                   change the reservation times, please contact the responsible
                                   official for this resource`,
  'reservation_cancel.cancel': 'Cancel reservation',
  'reservation_cancel.canceling': 'Canceling...',
  'reservation_cancel.do_not_cancel': 'Don\'t cancel reservation',
  'reservation_cancel.titleConfirm': 'Confirm cancellation',
  'reservation_cancel.titlePreliminary': 'Canceling reservation',
  'reservation_form.address': 'Address',
  'reservation_form.address_city': 'City',
  'reservation_form.address_street': 'Street address',
  'reservation_form.address_zip': 'Zip code',
  'reservation_form.back': 'Back',
  'reservation_form.billing_address': 'Billing address',
  'reservation_form.comments': 'Comments',
  'reservation_form.comments_help': 'Optional details of the reservation',
  'reservation_form.enter_valid_email': 'Please enter a valid email address',
  'reservation_form.event_description': 'Description',
  'reservation_form.field_max_length': 'The maximum length of the field is {maxLength} characters.',
  'reservation_form.must_accept_terms': 'You must accept the terms and ' +
                                        'conditions to reserve this resource',
  'reservation_form.number_of_participants': 'Number of participants',
  'reservation_form.read_terms': 'I have read and accept the terms and conditions',
  'reservation_form.required_field': 'Required information',
  'reservation_form.reserver_email': 'Email',
  'reservation_form.reserver_id': 'VAT ID / Social security number',
  'reservation_form.reserver_name': 'Reserver / Renter',
  'reservation_form.reserver_phone_number': 'Phone',
  'reservation_form.save': 'Save',
  'reservation_form.saving': 'Saving...',
  'reservation_form.staff_event': 'Staff event',
  'reservation_form.staff_event_help': `For staff events the only
                                        required field is the name of the reserver.`,
  'reservation_info.address': 'Address:',
  'reservation_info.back': 'Back',
  'reservation_info.billing_address': 'Billing address:',
  'reservation_info.comments': 'Comments:',
  'reservation_info.comments_help': 'Optional details of the reservation',
  'reservation_info.event_description': 'Description:',
  'reservation_info.help_title': 'Reservation instructions',
  'reservation_info.login_required': 'You must log in to make a reservation.',
  'reservation_info.max_period': `Maximum length of reservation:{days, plural,
            =0 {} one {\u00a0# day} other {\u00a0# days}}{hours, plural,
            =0 {} one {\u00a0# hour} other {\u00a0# hours}}{minutes, plural,
            =0 {} one {\u00a0# minute} other {\u00a0# minutes}}.`,
  'reservation_info.max_per_user': 'Maximum amount of reservations per user: {amount}',
  'reservation_info.number_of_participants': 'Number of participants:',
  'reservation_info.reservable_after_days': `Reservation must be made {days} {days, plural,
                                              one {day} other {days}} in advance.`,
  'reservation_info.reservation_time': 'Time of reservation',
  'reservation_info.reservation_info': 'Reservation info',
  'reservation_info.reserver_email': 'Email:',
  'reservation_info.reserver_id': 'VAT ID / Social security number:',
  'reservation_info.reserver_name': 'Reserver / Renter:',
  'reservation_info.reserver_phone_number': 'Phone:',
  'reservation_info.resource': 'Room:',
  'reservation_info.save': 'Save',
  'reservation_info.saving': 'Saving...',
  'reservation_list.no_reservations': 'You do not yet have any reservations.',
  'reservation_modal.confirm_help': `Are you sure you want to make {num, plural,
      one {a reservation for}
      other {reservations for}
      }:`,
  'reservation_modal.editing_after': 'After changes:',
  'reservation_modal.editing_are_you_sure': 'Are you sure you want to change your reservation?',
  'reservation_modal.editing_before': 'Before changes:',
  'reservation_modal.preliminary_form_help': `Please fill the following information. 
                                              Required fields are marked with an asterisk(*)`,
  'reservation_modal.preliminary_help': `You are making {num, plural, 
      one {a preliminary reservation for}
      other {preliminary reservations for}
      }:`,
  'reservation_modal.title_confirm': 'Confirm reservation',
  'reservation_modal.title_editing': 'Confirm changes',
  'reservation_modal.title_preliminary': 'Preliminary reservation',
  'reservation_page.reservation_status_title': 'Reservation status',
  'reservation_page.reserve_title': 'Reserve',
  'reservation_page.resource_info': 'Details',
  'reservation_page.title': '{resourceName} - reservation calendar - Varaamo',
  'reservation_success.info_email': `More specific information about the preliminary reservation 
                                     will be sent to the email address given during the 
                                     reservation `,
  'reservation_success.made_preliminary': `You have made a preliminary reservation to {name}
      for {times, plural, one {time} other {times} }:`,
  'reservation_success.sent': 'Your reservation request has been sent',
  'resource.image_alt': 'Picture of {resourceName}',
  'resource.reservation_status': 'Reservation status',
  'resource.reserve': 'Reserve',
  'resource.title': '{resourceName} - Varaamo',
  'search.help_text': 'Search for a room by entering some information in the search fields.',
  'search.no_results': 'No results found.',
  'search.page_header': 'Search',
  'search.title': 'Search - Varaamo',
  'search_controls.go_to_selected': 'Go to selected',
  'search_controls.search': 'Search',
  'search_controls.today': 'Today',
  'search_filters.purpose': 'Equipment, room or service',
  'search_filters.unit': 'Library',
  'search_result.details': 'Details',
  'search_result.hours_available': `{hours, plural,
      one {# hour}
      other {# hours}
      } available`,
  'search_result.reserve': '. Reserve.',
  'timerange.timestring': 'at {begin} \u2013 {end}',
  'timeslot.editing': 'Editing',
  'timeslot.free': 'Available',
  'timeslot.login_to_reserve': 'Log in to make a reservation.',
  'timeslot.not_reservable': 'Not reservable',
  'timeslot.reserved': 'Reserved',
  'timeslots.comments': 'Comments',
  'timeslots.functions': 'Functions',
  'timeslots.not_reservable_today': 'There are no reservable times on the selected day.',
  'timeslots.reserver': 'Reserver',
  'timeslots.status': 'Status',
  'timeslots.time': 'Time',
};

export default messages;



/** WEBPACK FOOTER **
 ** ./app/messages/en.js
 **/